module.exports = __webpack_public_path__ + "static/media/bunu_with_comp.66c47a5a.png";